var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('setting-scout-template-form',{on:{"submit":_vm.register}})}
var staticRenderFns = []

export { render, staticRenderFns }